import OrganizationDataService from "@/services/OrganizationDataService";

async function getCustomerCodeListOptions(data){
    return await OrganizationDataService.getCustomerCodeList(data)
    .then(res => {
        return res.data
    })
}

export default getCustomerCodeListOptions;